import { render, staticRenderFns } from "./multiselect-widget.vue?vue&type=template&id=15873044&scoped=true"
import script from "./multiselect-widget.vue?vue&type=script&lang=js"
export * from "./multiselect-widget.vue?vue&type=script&lang=js"
import style0 from "./multiselect-widget.vue?vue&type=style&index=0&id=15873044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15873044",
  null
  
)

export default component.exports